import React from "react";
import PollApp from "./components/PollApp";
import "./App.css";

function App() {
  return (
    <div className="zht-poll-root">
      <PollApp />
    </div>
  );
}

export default App;
